import React, { useEffect, useState } from 'react'
import { card, pkr, Section } from '.'
import { useApiCall } from '../../../component/custom-hooks/api-call';
import { set } from 'date-fns';
import DataNotFound from '../../../component/ui/loader/data-not-found';
import InnerLoader from '../../../component/ui/loader/inner-loader';
import { DollarSign, History, Loader, Receipt } from 'lucide-react';

const FxRate = ({ toast = () => { }, inpStyle, C }) => {
    // API FX RATE
    const [isLoading, setIsLoading] = useState(true);
    const apiCall = useApiCall();
    const [fxRate, setFxRate] = useState(0);
    const [fxNote, setFxNote] = useState("");
    const [fxHistory, setFxHistory] = useState([]);

    const fetchFxRate = async () => {
        setIsLoading(true);
        try {
            const res = await apiCall({ url: "cash-flow/fx-rates/list", method: "GET" });
            setFxHistory(res.data);
            setIsLoading(false);
            // Handle the response
        } catch (error) {
            console.error("Error fetching FX rate:", error);
            setIsLoading(false);
        }
    };

    const fetchFxRateLatest = async () => {
        try {
            const res = await apiCall({ url: "cash-flow/fx-rates/latest", method: "GET" });
            setFxRate((parseFloat(res?.data?.rate)?.toFixed(2)) || 0);
            setFxNote(res?.data?.note || "");
            // Handle the response
        } catch (error) {
            console.error("Error fetching latest FX rate:", error);
        }
    };

    const saveFxRate = async () => {
        try {
            const data = new Date().toISOString().slice(0, 10);
            const note = fxNote || "Manual update";
            const rate = parseFloat(fxRate);

            await apiCall({
                url: "cash-flow/fx-rates/add",
                method: "POST",
                data: { rate: rate, note: note, date: data }
            });

            toast("FX rate updated", "success");
            fetchFxRate();
            fetchFxRateLatest();
        } catch (error) {
            console.error("Error saving FX rate:", error);
            toast("Error updating FX rate", "error");
        }
    };

    // WHT Rate
    const [whtRate, setWhtRate] = useState(0);

    const fatchWHTRate = async () => {
        try {
            const res = await apiCall({ url: "cash-flow/wht-rate/detail", method: "GET" });
            setWhtRate((parseFloat(res?.data?.rate)?.toFixed(2)) || 0);
        } catch (error) {
            console.error("Error fetching WHT rate:", error);
        }
    };

    const saveWHTRate = async () => {
        try {
            const rate = parseFloat(whtRate);

            await apiCall({
                url: "cash-flow/wht-rate/add",
                method: "POST",
                data: { rate: rate }
            });
            toast("WHT rate updated", "success");
        } catch (error) {
            console.error("Error saving WHT rate:", error);
        }
    };

    useEffect(() => {
        fetchFxRate();
        fetchFxRateLatest();
        fatchWHTRate();
    }, []);

    return (
        <>
            {/* <Section id="fx" icon="💱" title="FX Rate" desc="Update the PKR/USD rate — all remittance calculations use this" C={C} card={card}>
                <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: 20 }}>

                </div>
            </Section> */}

            {/* Update rate */}
            <div style={{ ...card({ padding: "24px", background: "#fff" }) }}>
                <div className='text-sm font-bold text-black tracking-wide uppercase mb-4 flex items-center gap-1'>
                    <div style={{ color: C.accent }}>
                        <DollarSign size={'1em'} />
                    </div>
                    Update Current Rate
                </div>

                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr auto", gap: 16, alignItems: "end", marginBottom: 20 }}>
                    <div>
                        <label className='text-xs text-black block mb-2.5 font-semibold'>PKR per $1 USD</label>
                        <input type="number" value={fxRate} onChange={e => setFxRate(e.target.value)} step="0.01"
                            style={{ ...inpStyle, width: "100%", padding: "12px 14px" }} />
                    </div>
                    <div>
                        <label className='text-xs text-black block mb-2.5 font-semibold'>Note (optional)</label>
                        <input value={fxNote} onChange={e => setFxNote(e.target.value)} placeholder="e.g. Mar remittance"
                            style={{ ...inpStyle, width: "100%", padding: "12px 14px" }} />
                    </div>
                    <button onClick={saveFxRate}
                        className='py-2.5  px-6 rounded-lg text-sm flex items-center gap-2 justify-center font-bold text-white cursor-pointer transition-all'
                        style={{ background: C.accent, boxShadow: "0 4px 12px rgba(79,110,247,0.4)" }}>
                        <Loader size={'1em'} /> Update Rate
                    </button>
                </div>

                <div style={{ padding: "16px", borderRadius: 10, background: "linear-gradient(135deg, #f0f4ff, #faf5ff)", border: `1px solid #e0e7ff` }}>
                    <div className='text-sm font-bold mb-3' style={{ color: C.accent }}>
                        QUICK PREVIEW
                    </div>

                    <div style={{ display: "flex", gap: 20 }}>
                        <div className='text-xs flex flex-col gap-0.5' style={{ fontSize: 13, color: C.textSec }}>
                            <span>$1,000</span>
                            <span className='text-sm font-bold' style={{ color: C.accent }}>
                                {pkr(parseFloat(fxRate) * 1000)}
                            </span>
                        </div>

                        <div className='text-xs flex flex-col gap-0.5' style={{ fontSize: 13, color: C.textSec }}>
                            <span>$10,000</span>
                            <span className='text-sm font-bold' style={{ color: C.accent }}>
                                {pkr(parseFloat(fxRate) * 10000)}
                            </span>
                        </div>

                        <div className='text-xs flex flex-col gap-0.5' style={{ fontSize: 13, color: C.textSec }}>
                            <span>$15,000</span>
                            <span className='text-sm font-bold' style={{ color: C.accent }}>
                                {pkr(parseFloat(fxRate) * 15000)}
                            </span>
                        </div>
                        {/* <div style={{ fontSize: 13, color: C.textSec }}>$10,000 = <span style={{ fontWeight: 700, color: C.accent }}>{pkr(parseFloat(fxRate) * 10000)}</span></div> */}
                        {/* <div style={{ fontSize: 13, color: C.textSec }}>$15,000 = <span style={{ fontWeight: 700, color: C.accent }}>{pkr(parseFloat(fxRate) * 15000)}</span></div> */}
                    </div>
                </div>

                {/* Rate history */}
                <div className='pt-4'>
                    <div className='text-sm font-bold text-black tracking-wide uppercase mb-4 flex items-center gap-1'>
                        <div style={{ color: C.accent }}>
                            <History size={'1em'} />
                        </div>
                        Update Current Rate
                    </div>
                    {isLoading ? (
                        <div className="w-full h-[50px] flex items-center justify-center">
                            <InnerLoader />
                        </div>
                    ) : fxHistory.length < 1 ? (
                        <DataNotFound title={"FX rate history"} />
                    ) : (

                        <div style={{ borderRadius: 10, border: `1px solid ${C.border}`, overflow: "hidden" }}>
                            {fxHistory.slice(0, 1).map((h, i) => (
                                <div key={h.id} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "9px 14px", background: "#fafaf9" }}>
                                    <div className='flex gap-1 items-center'>
                                        <div style={{ fontSize: 12, fontWeight: 700, color: C.textPri }}>₨{parseFloat(h.rate)?.toFixed(2) || 0}</div>
                                        <div className='w-6 flex-shrink-0 bg-gray-400 h-px' />
                                        <div style={{ fontSize: 10, color: C.textMut, marginTop: 1 }}>{h.note}</div>
                                    </div>
                                    <div style={{ textAlign: "right" }}>
                                        <div style={{ fontSize: 10, color: C.textMut }}>{h.date}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>



            <div style={card({ padding: "20px 24px", marginBottom: 20 })}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                        <div
                            style={{
                                width: 40,
                                height: 40,
                                borderRadius: 11,
                                background: "linear-gradient(135deg,#fffbeb,#fef3c7)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                            }}
                        >
                            <Receipt size={20} />
                        </div>
                        <div>
                            <div style={{ fontSize: 14, fontWeight: 700, color: C.textPri }}>WHT Rate</div>
                            <div style={{ fontSize: 11, color: C.textMut }}>Withholding tax deducted on every remittance</div>
                        </div>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                        <input type="number" value={whtRate} onChange={e => setWhtRate(e.target.value)} step="0.01" min="0" max="5"
                            style={{ ...inpStyle, width: 80, fontSize: 18, fontWeight: 800, color: C.amber, textAlign: "center" }} />
                        <span style={{ fontSize: 16, fontWeight: 700, color: C.amber }}>%</span>
                        <button onClick={() => saveWHTRate()}
                            style={{ padding: "8px 18px", borderRadius: 9, border: "none", background: C.amber, fontSize: 12, fontWeight: 700, color: "#fff", cursor: "pointer" }}>
                            Save
                        </button>
                        <div style={{ padding: "8px 14px", borderRadius: 9, background: "#fffbeb", border: "1px solid #fde68a", fontSize: 12, color: C.amber }}>
                            On $15,000 → WHT = <strong>{pkr(15000 * fxRate * (whtRate / 100))}</strong>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default FxRate
